import { cx } from '@linaria/core';
import { useRef } from 'react';
import { avoidBreakSnapPoint, avoidBreakInside } from '@provider/print';
import { useKatex } from '@utils/react';
import { usePageContext } from '../../../../context.js';
import { useOpgavekompleksetComponent } from '../../../../state/context.data.js';
import { useTaskContext } from '../../context.js';
import { tileSelectors, content } from './_tile-input.style.js';
import { TileMoveIcon } from './atom.move-icon.js';
import { StateIcon } from './atom.state-icon.js';
import { useMaximumTileTextLength } from './context.js';
import { text } from './tile.text.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function TextTile(props) {
  const context = useTaskContext();
  const pageContext = usePageContext();
  const component = useOpgavekompleksetComponent();
  const ref = useRef(null);
  useKatex(ref);
  const widestText = useMaximumTileTextLength();
  return /*#__PURE__*/jsxs("span", {
    ref: ref,
    className: cx(content, text, props.className),
    "data-id": props.id,
    "data-type": "text",
    "data-wide-content": widestText >= 50,
    "data-size": props.size,
    "data-state": props.state,
    "data-context": context,
    "data-page-context": pageContext,
    "data-theme": props.facitTheme,
    "data-audience": component.data.settings.standalone.audience,
    "data-is-draggable": props.isDraggable,
    "data-is-overlay": props.isDragOverlay,
    ...avoidBreakInside({
      extend: {
        bottom: 10,
        top: 18
      }
    }),
    ...avoidBreakSnapPoint(),
    children: [/*#__PURE__*/jsx("span", {
      className: tileSelectors.content.className,
      children: props.text
    }), /*#__PURE__*/jsx(TileMoveIcon, {
      ...props
    }), /*#__PURE__*/jsx(StateIcon, {
      ...props
    })]
  });
}

export { TextTile };
//# sourceMappingURL=tile.text.js.map
